import {
  ChosenProduct,
  PackageType,
  ProductTypeFunnels,
} from "@b2bportal/core-packages";
import { createSelector } from "@reduxjs/toolkit";
import type { PackageState } from "../slice";

export const getCurrentActivePackage = (state: PackageState) => {
  return state.packages.base.currentActivePackage;
};

export const getCurrentActivePackageToken = (state: PackageState) => {
  return state.packages.base.currentActivePackage?.token.value;
};

export const getCurrentActivePackagePrice = (state: PackageState) => {
  return state.packages.base.currentActivePackage?.price;
};

export const getCurrentActivePackageExtraFields = (state: PackageState) => {
  return state.packages.base.currentActivePackage?.extraFields;
};

export const getCurrentActivePackageType = (state: PackageState) => {
  return state.packages.base.currentActivePackageType;
};

export const getFunnelsNeededForPackage = (state: PackageState) => {
  const packageType = getCurrentActivePackageType(state);
  return (
    ProductTypeFunnels[packageType] ??
    ProductTypeFunnels[PackageType.HOTEL_FLIGHT_CAR]
  );
};

const getBenchmarkProductsRaw = (state: PackageState) =>
  state.packages.base.benchmarkProducts?.chosenProducts;

export const getBenchmarkProducts = createSelector(
  getBenchmarkProductsRaw,
  (chosenProducts) => chosenProducts ?? []
);

export const getBenchmarkFlight = (state: PackageState) => {
  return state.packages.base.benchmarkProducts?.chosenProducts?.find(
    (product) => product.ChosenProduct === ChosenProduct.ChosenFlight
  );
};

export const getBenchmarkCar = (state: PackageState) => {
  return state.packages.base.benchmarkProducts?.chosenProducts?.find(
    (product) => product.ChosenProduct === ChosenProduct.ChosenCar
  );
};

export const getSelectedFlightCancellationPolicy = (state: PackageState) => {
  return state.packages.base.selectedFlightCancellationPolicy;
};

export const getSelectedCarCancellationPolicy = (state: PackageState) => {
  return state.packages.base.selectedCarCancellationPolicy;
};

export const getPendingChosenFlight = (state: PackageState) => {
  return state.packages.base.pendingChosenFlight;
};
